module.exports = __webpack_public_path__ + "static/media/choose_us_5.a6c6d3d0.png";